import {A, E} from './util.mjs'
import * as a from '@mitranim/js/all.mjs'
import * as dg from '@mitranim/js/dom_global'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as od from '@mitranim/js/obs_dom.mjs'
import * as u from './util.mjs'
import * as n from './net.mjs'
import * as d from './dat.mjs'
import * as c from './conf.mjs'
import * as ef from './elem-form.mjs'
import * as em from './elem-misc.mjs'

export class Suggs extends u.MixElemCtxSub(u.MixCycler(u.MixElem(od.MixReac(dg.global.HTMLElement)))) {
  static {dr.reg(this)}

  get CyclerChild() {return SuggBase}

  obs = new u.TaskObs()

  // Called manually.
  init() {return this.className = `block relative w-full h-0 mar-0-imp`, this}

  // Called automatically by `od.MixReac`.
  run() {
    const {task, error, value} = this.obs
    if (task) return this.drawLoading()
    if (error) return this.drawError(error)
    if (a.vac(value)) return this.drawItems(value)
    return this.drawEmpty()
  }

  drawLoading() {return this.drawList(SuggNone(`Loading...`))}
  drawError(err) {return this.drawList(new ef.FormMsg().setErr(err))}
  drawEmpty() {return this.drawList(SuggNone(`No suggestions found.`), SuggClose.init())}
  drawItems(src) {return this.drawList(a.arr(src).map(this.sugg, this), SuggClose.init())}
  drawList(...chi) {return E(this, {}, SuggList(...chi))}
  sugg(src, ind) {return new Sugg().init(src).setCurrent(!ind)}
  start() {return u.parseNum(this.dataset.start)}
  end() {return u.parseNum(this.dataset.end)}
  textarea() {return u.nodeByAttr(document, `data-suggs-id`, this.id)}
  reinit(inp) {this.obs.setTask(this.perform(inp))}

  async perform(inp) {
    inp = a.reqDict(inp)

    const start = a.reqNat(inp.start)
    const end = a.reqNat(inp.end)
    const text = a.reqStr(inp.text)

    this.dataset.start = start
    this.dataset.end = end
    this.dataset.text = text

    return this.fetchSels(this.ctxReinit(), text)
  }

  // Override in subclass.
  async fetchSels() {}

  // This method may be invoked without a current entry when the user presses
  // Enter while we're in a loading state.
  commitCurrent() {this.cyclerCurrent()?.exec()}

  commitText(text) {
    a.reqStr(text)

    const tar = this.textarea()
    if (!tar) return

    tar.replaceMention({
      start: this.start(),
      end: this.end(),
      text,
    })

    this.remove()

    // If the user used Tab to focus one of the suggestions, we want to return
    // focus to the target textarea.
    tar.focus()
  }
}

export class PersonSuggs extends Suggs {
  static {dr.reg(this)}

  // TODO switch to buket API and fetch only persons, no exts or aggs.
  async fetchSels(ctx, text) {
    return new d.AggPersons(await n.fetchPractitioners(ctx, {
      searchText: text,
      limit: c.FEED_SIZE_MEDIUM,
    })).selsBySlug()
  }
}

class SuggBase extends u.MixCyclerChild(em.MixExecableFakeBtn(u.MixElem(dg.global.HTMLLIElement))) {
  suggs() {return this.anc(Suggs)}
}

const CLS_SUGG = `row-bet-cen pad-sm`
const CLS_SUGG_BUSY = `hov-bg-pale`

export class Sugg extends SuggBase {
  static {dr.reg(this)}

  get A() {return A.cls(CLS_SUGG).cls(CLS_SUGG_BUSY)}

  init(src) {
    const {title, value} = u.reqSelectable(src)
    const valueCls = `fg-graphite`
    this.dataset.value = a.render(value)

    if (!title) {
      return E(this, this.A.cls(valueCls), `@`, value)
    }

    return E(this, this.A,
      title, E(`span`, A.cls(valueCls), ` @`, value),
    )
  }

  value() {return this.dataset.value}
  perform() {this.suggs().commitText(this.value())}
}

export class SuggClose extends SuggBase {
  static {dr.reg(this)}

  init() {
    return E(
      this,
      A.cls(CLS_SUGG).cls(CLS_SUGG_BUSY).cls(`fg-warm-gray`),
      `[Esc] to close, [↑↓Enter] to choose`,
    )
  }

  perform() {this.suggs().remove()}
}

// TODO avoid this wrapper. It exists only for CSS positioning reasons.
function SuggList(...chi) {
  return E(`div`, A.cls(`abs-t-l rig-0 block bg-white shad-std z-index-dialog pad-sm`), ...chi)
}

function SuggNone(...chi) {
  return E(`div`, A.cls(CLS_SUGG).cls(`fg-warm-gray`), ...chi)
}
